export const topics = [
  {
    id: "new-drama-finale",
    title: "新剧大结局播出，讨论区对开放式收尾吵成了两派",
    excerpt:
      "大结局没有给出明确答案，围观群众一边说“留白才高级”，一边说“追了四十集就这”。讨论区的连线从凌晨一直持续到第二天早上。",
    category: "film-tv",
    categoryName: "影视剧",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20flat%20illustration%20of%20an%20empty%20movie%20theater%20with%20glowing%20screen%20and%20rows%20of%20seats%2C%20coral%20red%20and%20cream%20color%20palette%2C%20subtle%20grain%20texture%2C%20editorial%20magazine%20style%2C%20soft%20evening%20lighting%2C%20clean%20minimal%20composition&width=1200&height=800&seq=hg-topic-drama-01&orientation=landscape",
    coverAlt: "新剧大结局讨论话题封面插画",
    tags: ["大结局", "开放式收尾", "剧情讨论", "追剧"],
    author: "瓜田值班员",
    authorRole: "影视讨论主理人",
    publishedAt: "2026-09-11",
    readMinutes: 6,
    views: 128400,
    comments: 2680,
    heat: 97,
    content: [
      "从开播到收官，这部剧在讨论区里几乎每周都会上一次热搜话题。到了大结局这一集，编剧选择把关键人物的去向留在了画面之外，屏幕黑下去的那一刻，围观群众的情绪彻底被点燃了。",
      "支持留白的观众认为，开放式收尾把想象空间还给了观众，人物的命运不需要被一句话钉死。他们在讨论区里列举了整部剧里埋下的伏笔，认为这些细节本身就已经构成了完整的答案。",
      "另一边的声音更直接：追剧四十集，最后却没等到一个说法。他们觉得留白和敷衍之间只隔着一层窗户纸，关键在于前面的铺垫是否足够扎实。这部分讨论往往会延伸到“什么才叫合格的收尾”。",
      "值得留意的是，两派吵到最后，讨论的重点已经从结局本身转移到了“我们为什么在意结局”这件事上。这大概也是这部剧最成功的地方——它让人愿意花几个小时，认认真真地聊一部剧。",
    ],
    highlights: [
      "大结局当晚讨论区新增观点 2680 条",
      "“留白党”与“交代党”势均力敌，各占约一半",
      "热度在播出后 6 小时达到峰值并持续升温",
    ],
    discussion: [
      {
        id: "d1",
        user: "柠檬味的风",
        handle: "@lemon_wind",
        time: "3 小时前",
        text: "我是留白党。最后一幕那个空椅子就是答案，非要台词说出来反而没意思了。",
        likes: 428,
        badge: "高赞观点",
      },
      {
        id: "d2",
        user: "追剧不打烊",
        handle: "@never_stop",
        time: "5 小时前",
        text: "理解留白，但四十集的感情总要有个落脚点吧，看完空落落的一晚上没睡着。",
        likes: 316,
      },
      {
        id: "d3",
        user: "路人甲在看",
        handle: "@passerby_a",
        time: "7 小时前",
        text: "两边别吵了，先把前面埋的伏笔盘清楚再说，我做了个时间线整理，评论区见。",
        likes: 205,
        badge: "整理达人",
      },
    ],
  },
  {
    id: "variety-guests-rumor",
    title: "新一季综艺录制路透流出，嘉宾阵容让讨论区提前过年",
    excerpt:
      "一组模糊的录制现场照片被发到讨论区，眼尖的网友从背影和站位里认出了好几位熟悉的面孔，阵容讨论瞬间刷屏。",
    category: "variety",
    categoryName: "综艺现场",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20flat%20illustration%20of%20colorful%20stage%20lights%20and%20spotlights%20over%20an%20empty%20variety%20show%20set%2C%20fresh%20green%20and%20amber%20palette%2C%20geometric%20shapes%2C%20editorial%20poster%20style%2C%20clean%20composition%20with%20open%20space&width=1200&height=800&seq=hg-topic-variety-02&orientation=landscape",
    coverAlt: "综艺录制路透讨论话题封面插画",
    tags: ["综艺", "路透", "嘉宾阵容", "名场面"],
    author: "瓜田信使",
    authorRole: "综艺观察员",
    publishedAt: "2026-09-10",
    readMinutes: 5,
    views: 96400,
    comments: 1740,
    heat: 92,
    content: [
      "路透照片的质量并不高，角度也歪，但讨论区里从来不缺眼尖的人。有人比对站位，有人研究服装，十几分钟之内，一份“疑似嘉宾名单”就被拼了出来。",
      "新一季节目的玩法据说会有比较大的改动，从现场布置来看，游戏区域的面积比上一季扩大了将近一倍。讨论区的猜测集中在“是不是要改成户外闯关”这一点上。",
      "嘉宾阵容的讨论则更加热闹。老面孔的回归让不少观众直呼“青春回来了”，新加入的几位也被寄予厚望，大家对他们的化学反应的期待值拉得很高。",
      "当然，路透终究只是路透。节目组目前还没有任何官方回应，讨论区里也出现了一些提醒大家“别过度解读”的声音，这种克制反而让讨论变得更有意思。",
    ],
    highlights: [
      "路透帖发布 40 分钟内讨论突破 500 条",
      "“阵容猜测”相关标签占据讨论区热榜前三",
      "多数观众期待户外玩法的改动",
    ],
    discussion: [
      {
        id: "d1",
        user: "综艺显微镜",
        handle: "@variety_scope",
        time: "1 小时前",
        text: "从场地布置看，这一季确实像户外闯关，游戏区比上季大太多了。",
        likes: 372,
        badge: "细节控",
      },
      {
        id: "d2",
        user: "快乐老家",
        handle: "@happy_home",
        time: "4 小时前",
        text: "老面孔回来我直接原地过年，就等官宣了，先蹲一下。",
        likes: 288,
      },
      {
        id: "d3",
        user: "理智吃瓜",
        handle: "@calm_melon",
        time: "6 小时前",
        text: "大家冷静点，路透不一定准，还是等节目组正式发阵容吧。",
        likes: 191,
      },
    ],
  },
  {
    id: "music-festival-night",
    title: "音乐节压轴夜全程高能，讨论区在线连线到散场",
    excerpt:
      "从傍晚到深夜，几组舞台轮番上场，讨论区的实时连线几乎没停过。散场之后，大家还在复盘今晚最出圈的那一段。",
    category: "music",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20flat%20illustration%20of%20an%20open%20air%20music%20festival%20crowd%20silhouette%20with%20warm%20stage%20glow%2C%20coral%20and%20amber%20gradient%20sky%2C%20artistic%20poster%20style%2C%20soft%20particles%2C%20clean%20layered%20composition&width=1200&height=800&seq=hg-topic-music-03&orientation=landscape",
    coverAlt: "音乐节压轴夜讨论话题封面插画",
    tags: ["音乐节", "现场", "舞台", "连线"],
    author: "现场连线员",
    authorRole: "音乐现场主理人",
    publishedAt: "2026-09-09",
    readMinutes: 5,
    views: 74200,
    comments: 1230,
    heat: 88,
    content: [
      "压轴夜的气氛是从天刚擦黑的时候开始起来的。第一组乐队上场时观众还在找位置，到了第三组，整个草坪已经站满了人，讨论区的连线提示音几乎没断过。",
      "当晚被讨论最多的是一段即兴改编。原曲的副歌被换成了另一种节奏，现场反应两极，有人觉得新鲜，有人觉得还是原版更好听，这个分歧一直延续到了散场。",
      "散场后的讨论区是最热闹的。大家一边等车一边复盘，把今晚的高光片段一条条列出来，还有人整理了整晚的歌单，方便没到现场的人补课。",
      "音乐节的好处大概就在这里：同一个夜晚，几万人有几种不同的记忆，而讨论区把这些记忆凑在了一起，变成一段更完整的现场。",
    ],
    highlights: [
      "压轴夜讨论区实时连线超过 1200 条",
      "即兴改编段落成为当晚讨论度最高的片段",
      "现场歌单整理帖被反复转发",
    ],
    discussion: [
      {
        id: "d1",
        user: "耳机党",
        handle: "@earphone_gang",
        time: "2 小时前",
        text: "那段即兴改编我现场听哭了，回家又循环了五遍，太顶了。",
        likes: 340,
        badge: "现场证人",
      },
      {
        id: "d2",
        user: "草坪第一排",
        handle: "@front_row",
        time: "5 小时前",
        text: "我还是更喜欢原版，改编有点用力过猛了，但现场氛围是真的好。",
        likes: 226,
      },
      {
        id: "d3",
        user: "补课中",
        handle: "@catch_up",
        time: "8 小时前",
        text: "求今晚完整歌单，没去现场的人急急急，感谢整理的大佬。",
        likes: 154,
      },
    ],
  },
  {
    id: "red-carpet-review",
    title: "年度红毯造型大盘点，谁的搭配成了当晚最难忘的记忆点",
    excerpt:
      "一晚上的造型看下来，讨论区从配色聊到剪裁，从配饰聊到妆发，最后票选出了三个最有记忆点的造型方向。",
    category: "fashion",
    categoryName: "时尚造型",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20flat%20illustration%20of%20a%20red%20carpet%20walkway%20with%20soft%20spotlights%20and%20fabric%20swatches%2C%20muted%20coral%20green%20and%20cream%20palette%2C%20minimal%20editorial%20fashion%20style%2C%20clean%20composition%20with%20negative%20space&width=1200&height=800&seq=hg-topic-fashion-04&orientation=landscape",
    coverAlt: "红毯造型盘点讨论话题封面插画",
    tags: ["红毯", "造型", "穿搭", "盘点"],
    author: "造型观察站",
    authorRole: "时尚讨论主理人",
    publishedAt: "2026-09-08",
    readMinutes: 7,
    views: 68900,
    comments: 980,
    heat: 84,
    content: [
      "红毯的魅力在于，它把一整年的审美偏好压缩到了一个晚上。今年的讨论区格外热闹，大家不再只盯着“好不好看”，而是开始聊为什么好看。",
      "配色是第一个被反复提到的点。低饱和的奶油色系和鲜亮的撞色同时出现，两种方向各自拥有支持者。有人觉得前者更耐看，也有人说红毯本来就是用来被记住的，亮点比稳妥重要。",
      "剪裁的讨论则更专业一些。廓形、腰线、裙摆的处理成了讨论区的关键词，几位见多识广的网友甚至把不同造型的剪裁思路画成了简图，方便大家对照着看。",
      "到投票环节，讨论区选出了三个最有记忆点的方向：极简线条、材质对比、以及一个意想不到的配饰巧思。这个结果比想象中更能说明今年的审美风向。",
    ],
    highlights: [
      "造型盘点帖累计投票超过 1.2 万次",
      "配色方向成为讨论区最高频关键词",
      "网友自制剪裁简图被大量转发",
    ],
    discussion: [
      {
        id: "d1",
        user: "衣柜爆满",
        handle: "@full_closet",
        time: "3 小时前",
        text: "低饱和那套真的耐看，第二年翻出来看也不会觉得过时。",
        likes: 298,
        badge: "高赞观点",
      },
      {
        id: "d2",
        user: "配色控",
        handle: "@color_geek",
        time: "6 小时前",
        text: "红毯就是要有点冲击力，稳过头反而记不住，我投撞色一票。",
        likes: 233,
      },
      {
        id: "d3",
        user: "剪裁爱好者",
        handle: "@tailor_fan",
        time: "9 小时前",
        text: "那件外套的肩线处理才是全场最妙的，细节比大色块好看多了。",
        likes: 187,
      },
    ],
  },
  {
    id: "idol-comeback-stage",
    title: "组合时隔许久正式回归，首个舞台讨论区循环播放到深夜",
    excerpt:
      "回归舞台上线之后，讨论区几乎被同一句话刷屏：编舞和现场完成度都超出预期，大家的复盘停不下来。",
    category: "music",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=dynamic%20flat%20illustration%20of%20a%20lit%20performance%20stage%20with%20abstract%20sound%20waves%20and%20green%20neon%20accents%2C%20cream%20and%20coral%20background%2C%20editorial%20poster%20style%2C%20clean%20geometric%20composition&width=1200&height=800&seq=hg-topic-comeback-05&orientation=landscape",
    coverAlt: "组合回归舞台讨论话题封面插画",
    tags: ["回归", "舞台", "编舞", "现场"],
    author: "舞台复盘组",
    authorRole: "现场讨论主理人",
    publishedAt: "2026-09-07",
    readMinutes: 5,
    views: 81300,
    comments: 1420,
    heat: 90,
    content: [
      "回归舞台上线的那一刻，讨论区就进入了一种奇妙的同步状态：所有人都在同一秒发出同一种感叹，然后开始逐帧复盘。",
      "舞台的完成度是这次讨论的焦点。走位、镜头、以及成员的舞台表现被拆开来看，讨论区里有人专门做了对照图，把几个关键段落和过往舞台放在一起比较。",
      "编舞部分的讨论最有意思。有网友指出，副歌的队形变化其实呼应了整支舞的主题，这种“藏在细节里的呼应”向来是讨论区最喜欢找的东西。",
      "到了深夜，讨论区的热度不降反升。有人循环播放了几十遍，有人开始整理舞台的时间轴，这种认真劲儿，大概就是回归舞台最迷人的地方。",
    ],
    highlights: [
      "回归舞台首日讨论突破 1400 条",
      "“编舞呼应”成为讨论区热门解析方向",
      "深夜时段互动量不降反升",
    ],
    discussion: [
      {
        id: "d1",
        user: "逐帧复盘",
        handle: "@frame_by_frame",
        time: "1 小时前",
        text: "副歌那个队形变化真的藏了主题，我截了九张图才看明白，太用心了。",
        likes: 366,
        badge: "细节控",
      },
      {
        id: "d2",
        user: "循环播放中",
        handle: "@on_repeat",
        time: "4 小时前",
        text: "已经循环三十遍了，镜头语言比上一支进步太多了，值得。",
        likes: 274,
      },
      {
        id: "d3",
        user: "路人转粉",
        handle: "@new_fan",
        time: "7 小时前",
        text: "不是粉也来夸一句，现场完成度确实高，难怪讨论区这么热闹。",
        likes: 162,
      },
    ],
  },
  {
    id: "livestream-moments",
    title: "直播间名场面合集流出，讨论区笑到停不下来",
    excerpt:
      "一场普通的直播因为几个即兴瞬间被顶上讨论区，网友们连夜剪出了合集，热度一路延伸到第二天。",
    category: "influencer",
    categoryName: "网红动态",
    cover:
      "https://readdy.ai/api/search-image?query=cheerful%20flat%20illustration%20of%20a%20smartphone%20livestream%20screen%20with%20floating%20heart%20and%20comment%20bubbles%2C%20warm%20amber%20and%20coral%20palette%2C%20playful%20editorial%20style%2C%20clean%20layered%20composition&width=1200&height=800&seq=hg-topic-live-06&orientation=landscape",
    coverAlt: "直播间名场面讨论话题封面插画",
    tags: ["直播", "名场面", "合集", "热议"],
    author: "瓜田剪辑台",
    authorRole: "动态跟进员",
    publishedAt: "2026-09-06",
    readMinutes: 4,
    views: 57800,
    comments: 860,
    heat: 81,
    content: [
      "这场直播本来没有特别的安排，就是普通的聊天，但因为几个临场反应，整场节奏突然变得很有意思，讨论区在直播中途就开始热闹起来。",
      "最先被截图的是一个毫无准备的瞬间。主播被弹幕逗笑，一句脱口而出的回应成了当晚的流行梗，第二天讨论区里全是相关的二次创作。",
      "随后出圈的是互动环节的处理方式。观众提出的问题五花八门，主播的接招方式既没有冷场，也没有刻意讨好，这种松弛感反而圈了一波路人。",
      "直播结束后，讨论区的作业就是剪合集。几个不同版本的名场面合集成型之后，热度继续往外扩散，成了当天讨论区里最轻松的一条话题。",
    ],
    highlights: [
      "直播中途讨论区热度已被点燃",
      "衍生梗在第二天持续发酵",
      "多个版本的合集成型并被广泛转发",
    ],
    discussion: [
      {
        id: "d1",
        user: "截图狂魔",
        handle: "@screenshot_king",
        time: "2 小时前",
        text: "那个被逗笑的瞬间我截了十张，做成表情包了，笑不活了。",
        likes: 302,
        badge: "高产作者",
      },
      {
        id: "d2",
        user: "路过的观众",
        handle: "@passing_by",
        time: "5 小时前",
        text: "本来只是路过，结果看完合集把整场直播都补了，真的放松。",
        likes: 218,
      },
      {
        id: "d3",
        user: "合集收集者",
        handle: "@clip_hoarder",
        time: "8 小时前",
        text: "三个版本的合集我都存了，各有各的剪法，建议都看一遍。",
        likes: 143,
      },
    ],
  },
  {
    id: "brand-collab-debate",
    title: "联名系列上线即售罄，讨论区从设计聊到购买体验",
    excerpt:
      "这次联名的设计走出了一条不常见的路线，讨论区的评价从一开始的分歧，慢慢聊成了一场关于“联名到底该怎么做”的讨论。",
    category: "fashion",
    categoryName: "时尚造型",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20flat%20illustration%20of%20folded%20fabric%20and%20garment%20tags%20with%20geometric%20patterns%2C%20muted%20green%20coral%20and%20cream%20palette%2C%20minimal%20editorial%20design%20style%2C%20clean%20balanced%20composition&width=1200&height=800&seq=hg-topic-collab-07&orientation=landscape",
    coverAlt: "联名系列讨论话题封面插画",
    tags: ["联名", "设计", "售罄", "体验"],
    author: "设计讨论组",
    authorRole: "时尚讨论主理人",
    publishedAt: "2026-09-05",
    readMinutes: 6,
    views: 61300,
    comments: 940,
    heat: 83,
    content: [
      "联名系列上线的第一天就售罄了，讨论区的反馈却并没有一边倒。有人冲着设计下单，也有人觉得这次的方向和预期不太一样。",
      "设计的争议主要集中在图案的处理上。这一次没有走常见的堆叠路线，而是做了大量的留白，喜欢的人觉得克制高级，不喜欢的人觉得“不够联名”。",
      "购买体验是另一个被频繁提到的话题。补货节奏、尺码选择、以及包装细节都在讨论范围内，讨论区里甚至有人把整个下单流程记录了下来，给后来的人做参考。",
      "讨论到最后，话题回到了原点：联名的价值究竟在图案本身，还是在它带来的那种参与感。这个问题没有标准答案，但讨论区显然很享受这个过程。",
    ],
    highlights: [
      "首发当日售罄，讨论区评价两极",
      "“留白设计”成为核心争议点",
      "下单流程记录帖被大量收藏",
    ],
    discussion: [
      {
        id: "d1",
        user: "极简派",
        handle: "@minimal_side",
        time: "3 小时前",
        text: "这次的留白我很喜欢，联名不一定非要把标志铺满整件衣服。",
        likes: 267,
        badge: "高赞观点",
      },
      {
        id: "d2",
        user: "老收藏家",
        handle: "@old_collector",
        time: "6 小时前",
        text: "说实话有点失望，等了这么久，联名的感觉不太够，图案太平了。",
        likes: 201,
      },
      {
        id: "d3",
        user: "抢货达人",
        handle: "@fast_buyer",
        time: "9 小时前",
        text: "抢到了，尺码偏小，建议大家比平时大一码，别问我是怎么知道的。",
        likes: 158,
      },
    ],
  },
  {
    id: "backstage-interview",
    title: "采访片段释出，主创聊起拍摄期间最难的一场戏",
    excerpt:
      "一段幕后采访被放到讨论区后，大家才发现那场看起来最平静的戏，其实是全组拍得最艰难的一段。",
    category: "backstage",
    categoryName: "幕后花絮",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20flat%20illustration%20of%20a%20film%20set%20with%20camera%20rig%20clapperboard%20and%20warm%20behind%20the%20scenes%20lighting%2C%20cream%20and%20green%20palette%2C%20editorial%20documentary%20style%2C%20clean%20minimal%20composition&width=1200&height=800&seq=hg-topic-backstage-08&orientation=landscape",
    coverAlt: "幕后采访片段讨论话题封面插画",
    tags: ["幕后", "采访", "拍摄", "主创"],
    author: "幕后记录员",
    authorRole: "花絮整理员",
    publishedAt: "2026-09-04",
    readMinutes: 5,
    views: 45600,
    comments: 620,
    heat: 76,
    content: [
      "这段采访原本只是宣传物料的一部分，但因为主创聊得太实在，被讨论区的网友专门拎出来单独发帖，热度很快就超过了很多正片相关的话题。",
      "被聊得最多的是那场“最难拍的戏”。从成片看，那场戏节奏缓慢、情绪克制，很难想象拍摄现场会那么折腾。主创提到，光是走位就调整了一整个下午。",
      "除了技术层面的难点，采访里还提到了一些有趣的小细节：比如某个道具其实是临时找来的，某个表情是演员的即兴发挥，这些都被讨论区的网友一一对照到了成片里。",
      "幕后内容的价值大概就在于此。它不会改变剧情，却能让观众重新理解那些看过的画面，原来每一个“理所当然”的瞬间背后，都有一段不为人知的折腾。",
    ],
    highlights: [
      "采访片段被单独发帖，热度超过多数正片话题",
      "“最难一场戏”的拍摄细节引发大量讨论",
      "即兴发挥的细节被网友逐一对照成片",
    ],
    discussion: [
      {
        id: "d1",
        user: "考据党",
        handle: "@detail_hunter",
        time: "2 小时前",
        text: "那个临时道具我真的找出来了，在第二集背景里出现过，太细了。",
        likes: 244,
        badge: "考据达人",
      },
      {
        id: "d2",
        user: "成片爱好者",
        handle: "@film_lover",
        time: "5 小时前",
        text: "知道幕后之后再看那场戏，完全不一样的感觉，平静之下全是功夫。",
        likes: 189,
      },
      {
        id: "d3",
        user: "幕后好奇",
        handle: "@curious_bts",
        time: "8 小时前",
        text: "希望多放点这种采访，比单纯宣传有意思多了，真的能学到东西。",
        likes: 131,
      },
    ],
  },
  {
    id: "variety-editing-rumor",
    title: "综艺剪辑引发讨论，观众开始复盘“被省略的那部分”",
    excerpt:
      "同一期节目，有人看到了笑点，有人看到了被剪掉的线索。讨论区里关于剪辑节奏的复盘，比节目本身还精彩。",
    category: "variety",
    categoryName: "综艺现场",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20flat%20illustration%20of%20film%20strips%20and%20timeline%20editing%20blocks%20over%20a%20cream%20background%2C%20coral%20and%20green%20accents%2C%20editorial%20infographic%20style%2C%20clean%20geometric%20layout&width=1200&height=800&seq=hg-topic-editing-09&orientation=landscape",
    coverAlt: "综艺剪辑讨论话题封面插画",
    tags: ["剪辑", "复盘", "节奏", "讨论"],
    author: "节奏观察员",
    authorRole: "综艺观察员",
    publishedAt: "2026-09-03",
    readMinutes: 5,
    views: 52400,
    comments: 780,
    heat: 79,
    content: [
      "剪辑这件事，平时观众很少会主动注意，但一旦节奏出了问题，讨论区立刻就能察觉。这一期节目就是典型的例子。",
      "最先被提到的是几个转场的处理。有网友指出，某些段落的衔接显得突兀，像是被硬生生地拼在了一起，代入感因此打了折扣。",
      "随之而来的是一场关于“被省略的部分”的复盘。大家根据预告、花絮和不同机位的画面，推断出可能被剪掉的内容，讨论区里拼线索的劲头相当足。",
      "当然，也有理性的声音提醒，剪辑是取舍的艺术，观众看到的永远只是成片。这种讨论本身其实很健康，它让综艺不只是被看，也被认真对待。",
    ],
    highlights: [
      "剪辑节奏成为讨论区核心话题",
      "网友自发拼凑“被省略内容”的线索",
      "理性讨论占比明显，观点交锋有序",
    ],
    discussion: [
      {
        id: "d1",
        user: "节奏控",
        handle: "@pace_master",
        time: "1 小时前",
        text: "中间那个转场真的有点硬，前一个镜头情绪还没落地就切走了。",
        likes: 231,
        badge: "细节控",
      },
      {
        id: "d2",
        user: "拼线索的人",
        handle: "@puzzle_guy",
        time: "4 小时前",
        text: "结合预告和花絮，至少有两段正片内容被拿掉了，讨论区已经拼出雏形了。",
        likes: 178,
      },
      {
        id: "d3",
        user: "温和派",
        handle: "@gentle_one",
        time: "7 小时前",
        text: "剪辑本来就是取舍，与其纠结剪掉了什么，不如聊聊留下来的部分好不好看。",
        likes: 142,
      },
    ],
  },
];